import * as React from "react";
import {
  Create,
  required,
  SimpleForm,
  TextInput,
} from "react-admin";
import { MonthDayInput } from "../../components/monthDayInput/MonthDayInput";

const validateTimePeriodEdit = (values) => {
  const errors: any = {};

  const start = new Date(values.start);
  const end = new Date(values.end);
  const startMD = start.getMonth() * 100 + start.getDate();
  const endMD = end.getMonth() * 100 + end.getDate();

  // Cross-year ranges (e.g. Oct-May) are valid, so we only
  // flag when both dates are the exact same day.
  if (startMD === endMD) {
    errors.end = `Start och slut kan inte vara samma dag`;
  }

  return errors;
};

export const TimePeriodCreate = () => {
  return (
    <Create>
      <SimpleForm
        validate={validateTimePeriodEdit}
      >
        <TextInput source="name" validate={[required()]} fullWidth />
        <MonthDayInput
          source="start"
          label="Start (månad & dag)"
          defaultValue={new Date(2000, 4, 15).toISOString()}
          validate={[required()]}
        />
        <MonthDayInput
          source="end"
          label="Slut (månad & dag)"
          defaultValue={new Date(2000, 8, 30).toISOString()}
          validate={[required()]}
        />
      </SimpleForm>
    </Create>
  );
};
